import bootstrapData from '../core/AppStructure/bootstrap_slice';
import portalData from '../core/AppStructure/portal_slice';
import members from '../components/Employees/members_slice';
import budgets from '../components/MealBudgets/budgets_slice';
import ui from '../core/AppStructure/ui_slice';
import groupsMembers from '../components/GroupsMembers/groups_members_slice';
import groups from '../components/Groups/groups_slice';
export default {
    bootstrapData: bootstrapData,
    portalData: portalData,
    members: members,
    budgets: budgets,
    ui: ui,
    groups: groups,
    groupsMembers: groupsMembers,
};
